import { useEffect } from "react";
import Button from "../../components/Button";

export default function Documents() {
  useEffect(() => {
    document.title = "Documents - Aldebaran";
  }, []);

  return (
    <div className="page">
      <div className="page__container">
        <header className="page__hero">
          <p className="page__eyebrow">Documents</p>
          <h1 className="page__title">Everything about DREAM, in one place</h1>
          <p className="page__lead">
            The protocol papers, token distribution, security reviews and brand
            assets behind Aldebaran - the auto-staking and auto-compounding
            protocol on TON.
          </p>
        </header>

        <section className="page__section">
          <h2>Protocol documents</h2>
          <div className="page__rows">
            <div className="page__row">
              <div>
                <p className="font-medium">Whitepaper</p>
                <span className="page__row-meta">
                  PDF · Protocol overview, staking model and emission curve
                </span>
              </div>
              <span className="page__badge">Coming soon</span>
            </div>

            <div className="page__row">
              <div>
                <p className="font-medium">Tokenomics</p>
                <span className="page__row-meta">
                  Markdown · Token distribution, vesting and treasury policy
                </span>
              </div>
              <span className="page__badge">Coming soon</span>
            </div>

            <div className="page__row">
              <div>
                <p className="font-medium">Security audit</p>
                <span className="page__row-meta">
                  Security review · 2024 · Smart-contract assessment
                </span>
              </div>
              <Button to="/audit" variant="ghost">
                View report
              </Button>
            </div>

            <div className="page__row">
              <div>
                <p className="font-medium">Brand assets</p>
                <span className="page__row-meta">
                  ZIP · Logos, wordmark and color tokens for partners
                </span>
              </div>
              <span className="page__badge">Coming soon</span>
            </div>
          </div>
        </section>

        <section className="page__section">
          <h2>Frequently asked questions</h2>
          <div className="page__prose">
            <h3>What is DREAM?</h3>
            <p>
              DREAM is the native token of Aldebaran, an auto-staking and
              auto-compounding protocol built on the TON blockchain. Holding
              DREAM puts your balance to work automatically - there is no manual
              claiming or restaking to manage.
            </p>

            <h3>How does auto-compounding work?</h3>
            <p>
              Staking rewards accrue continuously and are folded back into your
              position on each rebase cycle. Because rewards compound on-chain
              without a claim transaction, your effective balance grows on its
              own and you never pay gas to reinvest.
            </p>

            <h3>Is the protocol audited?</h3>
            <p>
              Yes. The contracts have been reviewed by an independent security
              firm, and the full report is published on the{" "}
              <a href="/audit">Audit page</a>. We recommend reading it before
              committing significant funds.
            </p>

            <h3>Are there lockups?</h3>
            <p>
              No fixed lockups for staked DREAM - you can unstake at any time.
              Treasury and team allocations follow a published vesting schedule,
              which is detailed in the Tokenomics document.
            </p>

            <h3>Which wallets are supported?</h3>
            <p>
              Any TON-compatible wallet works, with Tonkeeper as the
              recommended option. Connect through TON Connect to stake, track
              your compounding balance and participate in governance.
            </p>
          </div>
        </section>

        <div className="page__cta">
          <Button to="/instructions" className="btn--lg">
            Get started
          </Button>
        </div>
      </div>
    </div>
  );
}
